import { useEffect, useState } from 'react'
import { fetchPvDesktopLatest, type PvDesktopLatest } from '../lib/pvDesktopLatest'

/**
 * La última versión de TECOPOS escritorio, o `null` mientras llega o si no se
 * pudo leer. Con `null` la tarjeta enseña el enlace del CMS: el endpoint
 * mejora la página, nunca la bloquea.
 */
export function usePvDesktopLatest(): PvDesktopLatest | null {
  const [latest, setLatest] = useState<PvDesktopLatest | null>(null)

  useEffect(() => {
    const controller = new AbortController()
    void fetchPvDesktopLatest(controller.signal).then((value) => {
      if (!controller.signal.aborted) setLatest(value)
    })
    return () => controller.abort()
  }, [])

  return latest
}
